import { styled } from 'styletron-react';
import style from '../style';

export const ErrorMessage = styled('i', {
  padding: '0 1em',
  color: style.red,
  fontSize: '0.9em',
});
